<template>
  <div class="wrapper" v-if="data&&data.name!=='签约均价'">
    <div class="top">
      <span>{{data.name}}</span>
      <div class="report-tooltip" v-if="data.isTips">
        <!--:content="data.tips"-->
        <Tooltip  placement="top" >
          <div style="white-space:normal;" slot="content">{{data.tips}}</div>
          <img src="../../../assets/icon_info@2x.png" alt="">
        </Tooltip>

      </div>
    </div>
    <div class="middle" >
      <span>{{data.middleValue}}</span>
    </div>
<!--    <div class="bottom">-->
<!--      <div class="b-left">-->
<!--        <span class="mr8">{{data.leftName}}</span>-->
<!--        <span :class="['arrow', 'mr3',data.leftStatus===1?'up':(data.leftStatus===2?'down':'')]"></span>-->
<!--        <span>{{data.leftValue}}</span>-->
<!--      </div>-->
<!--      <div class="b-right">-->
<!--        <span>{{data.rightName}}</span>-->
<!--        <span>{{data.rightValue}}</span>-->
<!--      </div>-->
<!--    </div>-->



  </div>
</template>

<script>
  export default {
    name: "Cards",
    props:{
      data:{
        type:Object,
        default:null
      }

    },
    data(){
      return {
        // data:{
        //   "isTips": 0,
        //   "leftName": "string",
        //   "leftStatus": 0,
        //   "leftValue": "string",
        //   "middleValue": "string",
        //   "name": "string",
        //   "rightName": "string",
        //   "rightValue": "string",
        //   "tips": "string"
        // }

      }
    }



  }
</script>

<style scoped>
  .middle{

    font-size:18px;
    font-weight:500;
    color:rgba(73,80,96,1);
  }
  .wrapper{
    /*width:143px;*/
    width: 100%;
    height: 90px;
    /*height: ;*/
    /*border: 1px solid #DFDFDF;*/
    border-radius: 2px;
    /*border-left: 4px solid #CFA868 ;*/
    padding: 12px 14px ;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background:rgba(245,246,250,1);
    margin-bottom: 10px;
  }
  .top{
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-weight:500;
    color:rgba(125,134,153,1);
    font-size: 12px;
  }
  .top .report-tooltip{
    display: inline-block;
    width:13px ;
  }
  .top img{
    width: 13px;
    cursor: grab;
  }
  .bottom{
    display: flex;
    justify-content: space-between;
    /*margin-top: 10px;*/
  }
  .down{
    display: inline-block;
    border-top: 5px solid red ;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
  }
  .up{
    display: inline-block;
    border-bottom: 5px solid green ;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
  }
.mr8{
  margin-right: 8px;
}
.mr3{
  margin-right: 3px;
}

</style>
